import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initAnalytics } from "./utils/analytics.ts";

// Fire-and-forget, guarded twice: a no-op without a PostHog key, and a
// rejection here must never keep React from mounting.
void initAnalytics().catch(() => {});

createRoot(document.getElementById("root")!).render(<App />);
